<template>
  <v-container v-if="!$auth.state.uid">
    <v-layout align-center justify-center row>
      <v-flex shrink>
        <div class="display-3"></div>
      </v-flex>
    </v-layout>
  </v-container>
  <v-container v-else>
    <v-card>
      <v-card-title>
            <span class="headline">New files in supercruiser-raw</span>
      </v-card-title>
      <v-card-text>
        <v-layout row align-center justify-start>
          <v-flex class="mr-4" shrink>
            <v-menu
              ref="menu"
              v-model="pickFrom"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="humanFromDate"
                  label="From"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  style="width: 16em;"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fromDate" @input="pickFrom = false" />
            </v-menu>
          </v-flex>
          <v-flex shrink>
            <v-menu
              ref="menu"
              v-model="pickTo"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="humanToDate"
                  label="To (and including)"
                  placeholder="Today"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  style="width: 16em;"
                ></v-text-field>
              </template>
              <v-date-picker v-model="toDate" @input="pickTo = false" />
            </v-menu>
          </v-flex>
          <v-spacer />
          <v-flex v-if="events.length > 0">
            <v-text-field
              v-model="search"
              label="Search"
              hide-details
              clearable
              clear-icon="mdi-close"
              class="mb-3"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-flex v-if="false && progress && progress < 1">
        <v-progress-circular
          :rotate="-90"
          :value="progress*100"
          size="200"
        >
          {{status}}
        </v-progress-circular>
      </v-flex>
      <v-subheader v-if="progress && progress < 1">{{status}}</v-subheader>
      <v-flex style="width: 100%">
        <v-card
        v-if="events.length > 0"
        flat
        >
        <v-card-text>
          <v-treeview
          :items="events"
          :search="search"
          :filter="filter"
          :open.sync="open"
          item-key="Key"
          ref="tree"
          open-on-click
          class="events"
        >
          <template v-slot:prepend="{ item }">
            <v-icon
              v-if="item.children"
            >mdi-folder</v-icon>
          </template>
          <template v-slot:append="{ item }">
              <span class="mr-4">{{ item.ObjectSize | humansize}}</span>
              <span class="event-date">{{ item.Time | moment(dateFormat) }}</span>
          </template>
        </v-treeview>
      </v-card-text>
      </v-card>
      </v-flex>
      <v-subheader v-if="events.length === 0">No files were uploaded during the specified period</v-subheader>
  </v-card>
  </v-container>
</template>
<script>
import firebase from '@/plugins/firebase';
import moment from 'moment';

export default {
  mounted(){
    if (this.fromDate){
      this.fetchRange();
    }
  },
  data() {
    return {
      search: null,
      open: [],
      groupLevels: 2,
      dateFormat: 'dddd, MMMM Do YYYY',
      logFiles: [],
      status: '',
      progress: 0,
      pickFrom: false,
      pickTo: false,
      fromDate: moment().subtract(1, 'week').format().slice(0, 10),
      // fromDate: null,
      toDate: null,
      headers: [
        {
          text: 'Path',
          align: 'left',
          sortable: true,
          value: 'Key'
        },
        {
          text: 'Size',
          value: 'ObjectSize',
          sortable: true,
          width: '8%',  
          align: 'right',
        },
        {
          text: 'Time',
          value: 'Time',
          sortable: true,
          width: '15%',
          align: 'right',
        },
      ],
      expandGroup: null,
      totalSize: null,
      // events: [],
    }
  },
  computed: {
    humanFromDate(){
      if (!this.fromDate){
        return;
      }
      return moment(this.fromDate).format(this.dateFormat);
    },
    humanToDate(){
      if (!this.toDate){
        return;
      }
      return moment(this.toDate).format(this.dateFormat);
    },
    events(){
      let events = [];
      let keys = {};
      let groups = {};
      this.totalSize = 0;
      this.$store.getters['logs/events'](moment(this.fromDate, 'YYYY-MM-DD').unix(), moment(this.toDate, 'YYYY-MM-DD').unix()).forEach(event => {
        if (!keys[event.Key]){
          keys[event.Key] = true;
          let groupKey;
          try {
            groupKey = event.Key.match(/.*\//)[0];
          } catch {
            groupKey = null;
          }
          this.totalSize += event.ObjectSize;
          event.name = event.Key.split('/').pop();
          let childEvent = event;
          while(groupKey != null){
            let group;
            if (!groups[groupKey]){
              group = {
                Key: groupKey,
                ObjectSize: 0,
                Time: 0,
                children: [],
                name: groupKey.slice(0, -1).split('/').pop(),
              };
              groups[groupKey] = group;
            } else {
              group = groups[groupKey];
            }
            if (!group.children.includes(childEvent)){
              group.children.push(childEvent);
            }
            group.ObjectSize += event.ObjectSize;
            group.Time = Math.max(group.Time, event.Time);
            childEvent = group;
            try {
              groupKey = groupKey.slice(0, -1).match(/.*\//)[0];
            } catch {
              groupKey = null;
            }
          }
          if (!events.includes(childEvent)){
            events.push(childEvent);
          }
        }
      })
      return events;
    },
  },
  watch: {
    fromDate(){
      this.fetchRange();
    },
    toDate(){
      this.fetchRange();
    },
    search(search, from){
      if (!search){
        this.$refs.tree.updateAll(false);
      }
    }
  },
  methods: {
    filter (item, search, textKey) {
      if (!search || !textKey){
        this.open.length = 0;
        this.$refs.tree.updateAll(false);
        return;
      }
      for (let word of search.split()){
        if (item[textKey].toLowerCase().indexOf(word.toLowerCase()) === -1){
          return false;
        }
      }
      this.$refs.tree.updateAll(true);
      // let groupKey = item.Key;
      // while(groupKey){
      //   if (!this.open.includes(groupKey)){
      //     this.open.push(groupKey);
      //   }
      //   try {
      //     groupKey = groupKey.slice(0, -1).match(/.*\//)[0];
      //   } catch {
      //     groupKey = null;
      //   }
      // }
      return true;
    },
    fetchRange(){
      this.$store.dispatch('logs/fetchLogIndex', (status, progress) => {
          this.status = status;
          this.progress = progress;
        }).then(() => {
        this.$store.dispatch('logs/fetchRange', {from: moment(this.fromDate, 'YYYY-MM-DD').unix(), to: moment(this.toDate, 'YYYY-MM-DD').unix(), callback: (status, progress) => {
          this.status = status;
          this.progress = progress;
        }});
      });
      // }}).then(result => this.events = result);
    },
    // serialize(value){
    //   return(JSON.stringify(value));
    // },
    fetchLogIndex(){
      this.$store.dispatch('logs/fetchLogIndex', (status, progress) => {
        this.status = status;
        this.progress = progress;
      });
    },
  }
}
</script>